import Vue from 'vue';

class HomeSections {
    // Section 1
    static section1(configuration, locale, item) {
        new Vue({
            el: `#banners-item-${item}`,
            data: {
                configuration: configuration,
                loaded: false,
                locale: locale,
                name: `banners-item-${item}`,
                swiper: null,
            },
            mounted() {
                this.loaded = true

                setTimeout(() => {
                    this.swiper = new Swiper(`#banners-item-${item} #slider`, {
                        slidesPerView: "auto",
                        autoHeight: true,
                        spaceBetween: 0,
                        loop: true,
                        autoplay: {
                            delay: 8000,
                            disableOnInteraction: false,
                        },
                        pagination: {
                            el: `#banners-item-${item} .swiper-pagination`,
                            clickable: true,
                        }
                    });
                }, 200);
            }
        })
    }

    // Section 2
    static section2(configuration, locale, item) {
        new Vue({
            el: `#products-item-${item}`,
            data: {
                configuration: configuration,
                loaded: false,
                locale: locale,
                name: `products-item-${item}`,
            },
            mounted() {
                this.loaded = true
            }
        })
    }

    // Section 3
    static section3(configuration, locale, item) {
        new Vue({
            el: `#banners-item-${item}`,
            data: {
                configuration: configuration,
                loaded: false,
                locale: locale,
                name: `banners-item-${item}`,
                swiper: null,
            },
            mounted() {
                this.loaded = true

                setTimeout(() => {
                    this.swiper = new Swiper(`#banners-item-${item} #slider`, {
                        slidesPerView: "auto",
                        autoHeight: true,
                        spaceBetween: 0,
                        loop: true,
                        autoplay: {
                            delay: 8000,
                            disableOnInteraction: false,
                        },
                        pagination: {
                            el: `#banners-item-${item} .swiper-pagination`,
                            clickable: true,
                        }
                    });
                }, 200);
            }
        })
    }

    // Section 5
    static section5(configuration, locale, item) {
        new Vue({
            el: `#new-games-item-${item}`,
            data: {
                configuration: configuration,
                loaded: false,
                locale: locale,
                name: `new-games-item-${item}`,
            },
            mounted() {
                this.loaded = true
            }
        })
    }

    // Section 6
    static section6(configuration, locale, item) {
        new Vue({
            el: `#live-casino-item-${item}`,
            data: {
                configuration: configuration,
                loaded: false,
                locale: locale,
                name: `live-casino-item-${item}`,
            },
            mounted() {
                this.loaded = true
            }
        })
    }

    // Section 12
    static section12(configuration, locale, item) {
        new Vue({
            el: `#promoted-games-item-${item}`,
            data: {
                configuration: configuration,
                loaded: false,
                locale: locale,
                name: `promoted-games-item-${item}`,
                swiper: null,
            },
            mounted() {
                this.loaded = true

                setTimeout(() => {
                    this.swiper = new Swiper(`#promoted-games-item-${item} .swiper-container`, {
                        slidesPerView: 'auto',
                        autoHeight: true,
                        loop: true,
                        autoplay: {
                            delay: 4000,
                            disableOnInteraction: false,
                        },
                        navigation: {
                            nextEl: `#promoted-games-item-${item} .swiper-button-next`,
                            prevEl: `#promoted-games-item-${item} .swiper-button-prev`,
                        }
                    });
                }, 200);
            }
        })
    }
}
window.HomeSections = HomeSections;